import { createSelector } from 'reselect';
import get from 'lodash/get';
import { graphDataOrEmptyObjectSelector } from '../../../AdvWorkflow/AdvWorkflowSelector';
import { HOME_PURCHASE_GOAL_GRAPH_NODE } from '../../../HomePurchaseWorkflow/HomePurchaseWorkflowConstants';

const nullableDownPaymentSelector = createSelector(
  graphDataOrEmptyObjectSelector,
  graphDataOrEmpty => get(graphDataOrEmpty, `${HOME_PURCHASE_GOAL_GRAPH_NODE}.DownPayment`, null),
);

export default nullableDownPaymentSelector;
